export default "__VITE_ASSET__CXS75olM__"